import { EnvironmentSettings } from './environment-settings';

export const localEnvironmentSettings = {
    apiUrl: 'https://v1.everydatastore.org/restful/',
    demoMode: false,
    //mode: 'homepage'
};
